export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff?46fdbd2d897f8824e63c8862af60b24c";